import React from 'react';

import Error from '$/components/global/error/Error';
import Info from '$/components/global/info/Info';

import './index.scss';
import { Link } from 'react-router-dom';
import Loading from '$/components/loading/Loading';

export interface IEnterEmailProps {
  email: string;
  error?: string;
  success: boolean;
  isLoading: boolean;
  onSendEmail: React.FormEventHandler;
  onEmailChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  emailPlaceholder: string;
  successMessage: string;
}

export const EnterEmail: React.FC<IEnterEmailProps> = props => {
  const { emailPlaceholder, successMessage, email, error, success, isLoading, onSendEmail, onEmailChange } = props;

  const emailSent = success ? (
    <div>
      <Info>{successMessage}</Info>
      <Info>
        <Link className="link_underline" to={`/login`}>
          Login
        </Link>
      </Info>
    </div>
  ) : (
    <form className="login_form" onSubmit={onSendEmail}>
      <div className="login_label">Email</div>
      <input
        name="Email"
        id="Email"
        type="email"
        placeholder={emailPlaceholder}
        value={email}
        onChange={onEmailChange}
        maxLength={256}
      />
      <input type="submit" className="cta_btn login_submit" value="Send" disabled={isLoading} />
      {error && <Error>{error}</Error>}
    </form>
  );
  return isLoading ? (
    <div className="password_loading_spinner">
      <Loading color="primary" />
    </div>
  ) : (
    emailSent
  );
};

export default EnterEmail;
